import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_ADMIN_PLATFORM_SETTNGS,
    UPDATE_ADMIN_PLATFORM_SETTNGS,
  } from "./actionTypes"

import {
    getAdminPlatformSettingsSuccess,
    getAdminPlatformSettingsError,
    updateAdminPlatformSettingsSuccess,
    updateAdminPlatformSettingsError
} from "./actions"

import {
    genericGetRequest, genericPutRequest
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails, bsh_getInsuranceIoUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminPlatformSettings(action) {
    try {
        let admin_user = bsh_getAdminUserDetails();
        let master_user = bsh_getInsuranceIoUserDetails();
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_platform_settings`,
            action.payload?.queryParams,
            {
                Authorization: admin_user.token,
                "is-master": action?.payload?.is_master,
                "master-token": master_user?.token
            }
        )
        yield put(getAdminPlatformSettingsSuccess(response))
    } catch (error) {
        yield put(getAdminPlatformSettingsError(error))
    }
}

function* onUpdatePlatformSettings(action) {
    try {
        let admin_user = bsh_getAdminUserDetails();
        let master_user = bsh_getInsuranceIoUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_platform_settings/${action?.payload?.admin_platform_settings?.id}`;
        const payload = {
            body: JSON.stringify({...action.payload}),
            headers: {
              Authorization: admin_user.token,
              'Content-Type': 'application/json',
              "is-master": action?.payload?.is_master,
              "master-token": master_user?.token
            },
          }
        const response = yield call(genericPutRequest, URL, payload)
        yield put(updateAdminPlatformSettingsSuccess(response))
    } catch (error) {
        yield put(updateAdminPlatformSettingsError(error))
    }
}

function* AdminPlatformSettingsSaga() {
    yield takeEvery(GET_ADMIN_PLATFORM_SETTNGS, onGetAdminPlatformSettings)
    yield takeEvery(UPDATE_ADMIN_PLATFORM_SETTNGS, onUpdatePlatformSettings)
}

export default AdminPlatformSettingsSaga

